module.exports = __webpack_public_path__ + "img/menu_line@_icon.d7e5a6bd.svg";